/** Primary static academy logo served from the web app public folder. */
export const HEADER_ACADEMY_LOGO_PRIMARY_SRC = "/logos/LOGO_ACADEMIA.png";

/** Alternate static asset used on the public marketing header. */
export const HEADER_ACADEMY_LOGO_ALT_STATIC_SRC = "/logos/LOGO_ACADEMIA_AJUSTADO.png";

/** CDN fallback when static logo files are missing in the deployment. */
export const HEADER_ACADEMY_LOGO_CDN_FALLBACK_SRC =
  "https://archivos-academia.r2.dev/logo-academia.png";

/** Ordered fallback chain for header academy logos (all roles). */
export const HEADER_ACADEMY_LOGO_SOURCES = [
  HEADER_ACADEMY_LOGO_ALT_STATIC_SRC,
  HEADER_ACADEMY_LOGO_PRIMARY_SRC,
  HEADER_ACADEMY_LOGO_CDN_FALLBACK_SRC,
];

export const HEADER_ACADEMY_LOGO_ALT = "Logo Academia";

export const HEADER_PROFILE_ICON_SRC = "/logos/LOGO_PERFIL.png";

/**
 * @param {string} currentSrc
 * @param {readonly string[]} [sources]
 * @returns {string | null}
 */
export function getNextHeaderLogoSource(currentSrc, sources = HEADER_ACADEMY_LOGO_SOURCES) {
  const index = sources.indexOf(currentSrc);
  if (index < 0 || index >= sources.length - 1) {
    return null;
  }
  return sources[index + 1];
}
